import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'summaryFidelity',
    label: 'Summary Fidelity',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
